export const THEME_PRESETS = [
  {
    id: "midnight",
    name: "Midnight Galaxy",
    description: "Dark navy with subtle cyan highlights.",
    colors: {
      bgLinearStart: "#02040d",
      bgLinearMid: "#060b1f",
      bgLinearEnd: "#070914",
      nebulaA: "rgba(92, 68, 170, 0.24)",
      nebulaB: "rgba(44, 104, 202, 0.26)",
      nebulaC: "rgba(88, 56, 136, 0.16)",
      neonCyan: "#51e5ff",
      neonPurple: "#9d6eff",
      neonPink: "#ff5fcf",
    },
  },
  {
    id: "aurora",
    name: "Aurora Drift",
    description: "Cool teal aurora with deep ocean shadows.",
    colors: {
      bgLinearStart: "#031016",
      bgLinearMid: "#061826",
      bgLinearEnd: "#040d15",
      nebulaA: "rgba(36, 170, 170, 0.25)",
      nebulaB: "rgba(37, 119, 219, 0.24)",
      nebulaC: "rgba(24, 110, 138, 0.15)",
      neonCyan: "#66f2ff",
      neonPurple: "#6ca3ff",
      neonPink: "#4de7c9",
    },
  },
  {
    id: "cosmic-rose",
    name: "Cosmic Rose",
    description: "Deeper magenta galaxy with violet glow.",
    colors: {
      bgLinearStart: "#110716",
      bgLinearMid: "#1a102b",
      bgLinearEnd: "#0f0919",
      nebulaA: "rgba(155, 64, 138, 0.26)",
      nebulaB: "rgba(92, 84, 214, 0.24)",
      nebulaC: "rgba(180, 76, 132, 0.16)",
      neonCyan: "#7ad7ff",
      neonPurple: "#c188ff",
      neonPink: "#ff76b2",
    },
  },
  {
    id: "terminal-matrix",
    name: "Terminal Matrix",
    description: "Retro terminal green with deep black-tech backdrop.",
    colors: {
      bgLinearStart: "#010807",
      bgLinearMid: "#02110f",
      bgLinearEnd: "#010605",
      nebulaA: "rgba(38, 175, 122, 0.22)",
      nebulaB: "rgba(22, 124, 99, 0.2)",
      nebulaC: "rgba(14, 84, 66, 0.16)",
      neonCyan: "#63ffc2",
      neonPurple: "#47c98f",
      neonPink: "#b5ffd8",
    },
  },
  {
    id: "sunset-drive",
    name: "Sunset Drive",
    description: "Warm orange horizon blended with indigo night.",
    colors: {
      bgLinearStart: "#12090d",
      bgLinearMid: "#26142a",
      bgLinearEnd: "#0c0a15",
      nebulaA: "rgba(222, 114, 70, 0.26)",
      nebulaB: "rgba(151, 88, 226, 0.24)",
      nebulaC: "rgba(222, 156, 90, 0.16)",
      neonCyan: "#7de9ff",
      neonPurple: "#d18bff",
      neonPink: "#ff9f6f",
    },
  },
  {
    id: "ice-core",
    name: "Ice Core",
    description: "Frozen blue chrome with crisp sci-fi highlights.",
    colors: {
      bgLinearStart: "#04111e",
      bgLinearMid: "#0a2034",
      bgLinearEnd: "#07121f",
      nebulaA: "rgba(94, 170, 230, 0.26)",
      nebulaB: "rgba(66, 208, 255, 0.22)",
      nebulaC: "rgba(76, 128, 208, 0.16)",
      neonCyan: "#8befff",
      neonPurple: "#86b8ff",
      neonPink: "#65d7ff",
    },
  },
  {
    id: "infrared",
    name: "Infrared Signal",
    description: "Dark tactical red with high-energy accents.",
    colors: {
      bgLinearStart: "#12060a",
      bgLinearMid: "#1b0d17",
      bgLinearEnd: "#09050b",
      nebulaA: "rgba(212, 68, 90, 0.25)",
      nebulaB: "rgba(181, 52, 111, 0.22)",
      nebulaC: "rgba(146, 44, 74, 0.16)",
      neonCyan: "#ff8ca8",
      neonPurple: "#ff6f95",
      neonPink: "#ffb38f",
    },
  },
];

export const CURSOR_MODES = [
  { id: "music", label: "Music Note" },
  { id: "default", label: "System Arrow" },
  { id: "neon", label: "Neon Dot" },
];

export const EFFECT_MODES = [
  { id: "classic", label: "Classic Galaxy" },
  { id: "dust", label: "Cosmic Dust" },
  { id: "cinematic", label: "Cinematic Haze" },
  { id: "quantum-grid", label: "Quantum Grid" },
  { id: "orbital-wave", label: "Orbital Wave" },
  { id: "solar-wind", label: "Solar Wind" },
];

export const DEFAULT_THEME_SETTINGS = Object.freeze({
  presetId: "midnight",
  starDensity: 1,
  starSpeed: 1,
  twinkleIntensity: 1,
  nebulaIntensity: 1,
  effectIntensity: 1,
  cursorMode: "music",
  effectMode: "classic",
});

export function getThemePresetById(presetId) {
  return THEME_PRESETS.find((preset) => preset.id === presetId) || THEME_PRESETS[0];
}
